import React from "react";

import "css/Loading.css";

const Loading = ({ text = "Fetching..." }) => {
    let showText = true;
    if (text === false) {
        showText = false;
    }

    return (
        <div className="Loading">
            <div className="qb-logo" />
            {showText && <div className="spinner-info">{text}</div>}
        </div>
    );
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading.js